/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
export default {
  isLoading,
  doneLoading,
  isLoadingCertificates,
  doneLoadingCertificates,
  setList,
  updateSelectedCertificates,
  clearSelectedCertificates,
  resetSearchFields,
  resetState
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}

function isLoadingCertificates (state) {
  state.loadingCertificates = true
}

function doneLoadingCertificates (state) {
  state.loadingCertificates = false
}

function setList (state, { certificates }) {
  state.list = certificates
}

function updateSelectedCertificates (state, selectedCertificates) {
  state.selectedCertificates = [...selectedCertificates]
}

function clearSelectedCertificates (state) {
  state.selectedCertificates = []
}

function resetSearchFields (state) {
  state.searchFields = _.cloneDeep(initialState.searchFields)
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })

  state = { ...initialState }
}
